'use strict';

angular.module('amexReconciliationApp')
    .service('BtaAccountModel',
        function BtaAccountModel($rootScope, ModelFactory) {
        var btaAccountModel = ModelFactory.create('BtaAccountModel', ['statements']);

        return btaAccountModel;
        });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/BtaAccountModel.js
// module id = 576
// module chunks = 0